import { render, staticRenderFns } from "./KisOverview.vue?vue&type=template&id=8cb72f38"
import script from "./KisOverview.js?vue&type=script&lang=js&external"
export * from "./KisOverview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports